export default {
	/**
	 * @param {string} key
	 * @param {string} value
	 */
	set (name, value) {
		if (window.localStorage) {
			window.localStorage.setItem(name, JSON.stringify(value))
		}
	},
	/**
	 * @param {string} name
	 * @returns {Array}
	 */
	get (name, success) {
		let output = []
		if (window.localStorage) {
			let item = JSON.parse(window.localStorage.getItem(name))
			if (item === null) {
				return output
			} else {
				const length = Object.keys(item).length
				if (length === 0) return output
				for (let key in item) {
					output.push(item[key])
				}
				return output
			}
		}
	},
	/**
	 * @param {string} key
	 */
	remove (name) {
		if (window.localStorage) {
			window.localStorage.removeItem(name)
		}
	}
}



// WEBPACK FOOTER //
// ./src/providers/ls.js